
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";
import initialsHelper from "@/helpers/cardInfoHelperFunctions/initialsHelper";
import { hslColorFromName } from "@/utils/hslColorFromName";
@Component({
  components: {
    S3Image,
  }
})
export default class SchedulerItemAvatar extends Vue {
  @Prop({ type: String, default: undefined }) readonly avatar?: string;
  @Prop({ type: String, default: undefined }) readonly title!: string;
  @Prop({ type: Boolean, default: true }) readonly small!: boolean;
  selected: boolean = true
  get outerContainerSize(): string {
    return this.small ? "h-8 w-8" : "h-9 w-9";
  }
  get innerContainerSize(): string {
    return this.small ? "h-7 w-7" : "h-8 w-8";
  }
  get initials(): string {
    if (!this.title) {
      return "";
    }
    return initialsHelper(this.title);
  }


  get bgStyle(): object {
    return {
      background: hslColorFromName(this.initials.trim().toLowerCase() || ""),
    };
  }

  mouseover() {
    if (this.selected ){
      this.$emit('mouseover')
      this.selected = false
    }
    else {
      this.$emit('mouseleave')
      this.selected = true
    }
  }
  mouseleaves() {
    this.$emit('mouseleave')
  }
  click() {
    this.$emit('click')
  }
}
